import {
  CourseTypes,
  CourseTypesLabels,
  ModalityLabels,
  ModalityTypes,
} from '@/models/catalog/course';

export const modalityTypesLabels = {
  [ModalityTypes.Online]: ModalityLabels.Online,
  [ModalityTypes.LiveOnline]: ModalityLabels.LiveOnline,
  [ModalityTypes.Hybrid]: ModalityLabels.Hybrid,
  [ModalityTypes.InPerson]: ModalityLabels.InPerson,
  [ModalityTypes.PrivateClass]: ModalityLabels.PrivateClass,
};

export const courseTypesLabels = {
  [CourseTypes.NonDegree]: CourseTypesLabels.NonDegree,
  [CourseTypes.Languages]: CourseTypesLabels.Languages,
  [CourseTypes.Undergraduate]: CourseTypesLabels.Undergraduate,
  [CourseTypes.Postgraduate]: CourseTypesLabels.Postgraduate,
  [CourseTypes.Technical]: CourseTypesLabels.Technical,
  [CourseTypes.Mentorship]: CourseTypesLabels.Mentorship,
};
